export default __webpack_public_path__ + "static/media/Intimation_of_Commencement_of_Commercial_Production_in_Punjab.6df660f7.pdf";